import flag_de from 'flag-icons/flags/4x3/de.svg';
import flag_gb from 'flag-icons/flags/4x3/gb.svg';
import flag_hu from 'flag-icons/flags/4x3/hu.svg';
import flag_pl from 'flag-icons/flags/4x3/pl.svg';
import flag_ua from 'flag-icons/flags/4x3/ua.svg';
import { notFound } from 'next/navigation';

/**
 * Configs
 */
export const LocaleList = [
  { flag: flag_hu, value: 'hu', hreflang: 'hu-HU' },
  { flag: flag_gb, value: 'en', hreflang: 'en-GB' },
  { flag: flag_de, value: 'de', hreflang: 'de-DE' },
  { flag: flag_ua, value: 'uk', hreflang: 'uk-UA' },
  { flag: flag_pl, value: 'pl', hreflang: 'pl-PL' },
] as const;
export const locales = LocaleList.map(({ value }) => value);

/**
 * Utilities
 */
export async function getLocale(locale: string) { try { return import(`@@i18n/locales/${locale}.json`).then((data) => data.default); } catch (error) { notFound(); } } //prettier-ignore
